<template>

	<header class="col-xs-12 npd mainhead">
		<section class="col-xs-12 topnav">
			<div class="container">
				<div class="row">
					<router-link :to="{ name: 'Inicio' }" class="logo">
						<img v-bind:src="theme_url+'/html/assets/img/logo.svg'" alt="">
					</router-link>
					<nav class="menu">
						<button class="navbut">
							<span class="bar"></span>
							<span class="bar"></span>
							<span class="bar"></span>
						</button>
						<ul>
							<li v-for="menu in menus">
								<router-link :to="menu.url">{{ menu.title }}</router-link>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</section>
		<section class="col-xs-12 subnav">
			<div class="container">
				<div class="row">
						<proximosprogramas></proximosprogramas>
						<buscador></buscador>
					<ul class="social">
						<li v-for="(value, key) in sm">
							<a v-bind:href="value" target="_blank">
								<i v-bind:class="'fa '+key"></i>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>
	</header>


</template>

<script>
export default {
	mounted: function() {
		// console.log( rtwp.api.collections );
		this.getMenu();
		this.getSM();
	},
	data() {
		return {
			menus: [],
			sm: [],
			site_name: rtwp.site_name,
			theme_url: rtwp.theme_url
		};
	},
	methods: {
		getMenu: function() {
			const vm = this;
			vm.$http.get( 'wp-api-menus/v2/menu-locations/primary-menu' )
			.then( ( res ) => {
				vm.menus = res.data;
			} )
			.catch( ( res ) => {
				console.log( 'Something went wrong :'+res );
			} );
		},

		getSM: function() {
			const vm = this;
			vm.$http.get( 'yoast/sm' )
			.then( ( res ) => {
				vm.sm = res.data;
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				console.log( 'Something went wrong :'+res );
			} );
		}
	}
};
</script>



// WEBPACK FOOTER //
// theme-header.vue?6b6f4d05